import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from 'src/app/common/shared.module';
import { ToastV2Service } from 'src/app/services/toast-v2.service';

@Component({
  selector: 'app-toasts-v2',
  imports: [ToastModule, SharedModule, CommonModule],
  templateUrl: './toasts-v2.component.html',
})
export class ToastsV2Component {
  constructor(private readonly toastService: ToastV2Service) {}

  onActionClick(message: any, closeFn: (event?: Event) => void): void {
    const actionId = message?.data?.actionId;
    if (actionId) {
      this.toastService.emitAction(actionId);
    }
    closeFn?.();
  }
}
